<template>
  <v-server-table
    :columns="columns"
    :options="tableOptions"
    @row-click="redirectToAccount"
    @filter="onFilterUpdate"
    id="accountsTable"
    ref="accountsTable"
    name="accountsTable"
  >
    <span slot="afterFilter" v-if="showQueryResetIcon">
      <i class="fa fa-times reset-filter" @click="resetQueryFilter"></i>
    </span>
    <span slot="name" slot-scope="props">
      <span>{{ props.row.first_name }} {{ props.row.last_name }}</span>
    </span>
    <span slot="birthdate" slot-scope="props">
      <span>{{ $options.filters.localTime(props.row.birthdate, 'DD/MM/YYYY')}}</span>
    </span>
    <span slot="created_at" slot-scope="props">
      <span>{{ $options.filters.localTime(props.row.created_at, 'YYYY-MM-DD HH:mm')}}</span>
    </span>
    <span slot="info" slot-scope="props">
      <span :title="`${props.row.hearing_tests_count} ${$t('references.table.hearing_test')}`" v-if="props.row.hearing_tests_count && props.row.hearing_tests_count > 0">
        <i class="fa fa-headphones"></i>
      </span>
      <span :title="`${props.row.hearing_training_count} ${$t('clinical.accounts.details.hearing_training')}`" v-if="props.row.hearing_training_count && props.row.hearing_training_count > 0">
        <i class="fa fa-trophy"></i>
      </span>
    </span>
  </v-server-table>

</template>

<script>
import TableQueryMixin from '@/mixins/TableQueryMixin'

export default {
  props: {
    service: {
      type: Object,
      required: true
    },
    querySearch: {
      type: String,
      required: false
    },
  },
  mixins: [
    TableQueryMixin
  ],
  data: function () {
    return {
      filters: {
        querySearch: null
      },
      columns: [
        'created_at',
        'name',
        'phone',
        'email',
        'birthdate',
        'info'
        // 'status',
      ],
      component: {
        name: 'clinical/accounts'
      },
      queryUrl: `${this.service.url}/admin/users`,
      tableOptions: {
        saveState: true,
        filterable: ['name', 'email', 'phone'],
        sortable: ['name', 'email', 'phone', 'created_at'],
        headings: {
          name: this.$t('tables.columns.name'),
          phone: this.$t('tables.columns.phone'),
          birthdate: this.$t('tables.columns.birthdate'),
          created_at: this.$t('tables.columns.created_at'),
          actions: this.$t('tables.columns.actions')
        },
        columnsClasses: {
          results: 'results',
          actions: 'actions',
        }
      }
    }
  },
  methods: {
    redirectToAccount: function ({ row }) {
      this.$router.push({ name: `${this.service.slug}clinical/accounts/id`, params: { id: row.id } })
    },
    getTableReference: function () {
      return this.$refs.accountsTable
    }
  },
  watch: {
    querySearch: {
      handler: function (value) {
        this.filters.querySearch = value || ''
      },
      immediate: true
    },
    'filters.querySearch': function (value) {
      this.$refs.accountsTable.setFilter(value)
      this.$emit('filters-updated', { filters: this.filters, count: this.activeFilterCount })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
